/* eslint-disable eqeqeq */
import React from 'react';
import offerwallIcon from '../icons_android/order_offerwall.svg';
import { openUrl } from '../custom_views/insta_custom_views/utils_android/AndroidMethods';
import { getGoogleId } from '../custom_views/insta_custom_views/utils_android/CookieHelper';

// Offerwall CPA-сети CPALead (www.cpalead.com).
// Direct Link из кабинета CPALead. subid добавляется при клике —
// в него передаём google id юзера, он вернётся в postback для начисления награды.
const CPALEAD_OFFERWALL_URL = "https://www.lnksforyou.com/wall/gNtulo"

// ТЕСТОВЫЙ РЕЖИМ: итем виден только тестовым аккаунтам и на localhost.
// Когда offerwall будет готов к релизу — поставить false.
const OFFERWALL_TEST_MODE = true
const TEST_GOOGLE_IDS = ["111721080232915624716", "115617333779596885662"]

export const isShowOfferwallTask = () => {
    if (!OFFERWALL_TEST_MODE) {
        return true
    }
    return TEST_GOOGLE_IDS.includes(getGoogleId() + "") || window.location.href.includes("localhost")
}

const OfferwallTaskItem = () => {
    const openOfferwall = () => {
        const separator = CPALEAD_OFFERWALL_URL.includes("?") ? "&" : "?"
        openUrl(CPALEAD_OFFERWALL_URL + separator + "subid=" + getGoogleId())
    }
    return (
        <div className="task_item_container hover" onClick={openOfferwall}>
            <div className="flex task_item_full_width">
                <img className="task_item_icon custom_icons_task_shadow" src={offerwallIcon} alt="" />
                <div className="block justify_content task_item_full_width">
                    <p className="task_item_title task_name_overflow">Задания от партнёров</p>
                    <p className="task_item_type description_full custom_desc">Выполняйте задания партнёров и получайте награду</p>
                </div>
            </div>
        </div>
    );
}

export default React.memo(OfferwallTaskItem);
